sn-esignature-features {
  // Layout styles copied from features-type-8
  .sn-esignature-features__cards {
    display: flex;
    align-items: stretch;

    > * {
      flex: 1 1 0;
      min-width: 0;
    }
  }

  .sn-esignature-features__cards--triple {
    gap: var(--spacing-4xl);
  }

  .sn-esignature-features__cards--quad {
    gap: var(--spacing-2xl);
  }

  .sn-esignature-features__cards--six {
    flex-wrap: wrap;
    gap: var(--spacing-2xl);
    align-items: stretch;

    > * {
      flex: 0 0 calc((100% - var(--spacing-2xl) * 2) / 3);
      min-width: 0;
      display: flex;
    }

    @media (width <= 1024px) {
      > * {
        flex: 0 0 calc((100% - var(--spacing-2xl)) / 2);
      }
    }

    @media (width <= 768px) {
      > * {
        flex: 0 0 100%;
      }
    }
  }

  .features-card-type-6 {
    padding: var(--spacing-2xl);

    @include desktop {
      padding: var(--spacing-4xl);
    }

    .features-card-type-6__icon {
      flex-shrink: 0;
    }

    me-heading[slot='heading'] {
      flex-shrink: 0;
    }

    me-text[slot='description'] {
      flex-grow: 1;
    }
  }
}

features-card-type-6 {
  display: flex;
  flex-direction: column;
}
